
export const EMT_ORDER: { [key: number]: number } = {
  936: 0, // Planes en familia
  938: 1, // Aventura y exploración
  939: 2, // Experiencias temáticas
  941: 3, // Escapadas románticas
  937: 4, // Ambiente inclusivo y diverso
  942: 5, // Experiencias tranquilas
  943: 6 // Social y conexión
};